import ToolTip from 'Components/ToolTip';
import React from 'react'
import { Order } from 'shared/constants'

const VoyageTableHeadComponent = ({ setOrder, order, tab, previousVoyage=false }: any) => {
    const [hoverId, setHoverId] = React.useState<string | null>(null);

    const toggleOrder = () => {
        setOrder(order === Order.ASC ? Order.DESC : Order.ASC);
        setHoverId(null);
    };

    return (
        <thead className="table-light">
            <tr>
                <th className='p-2 align-middle sr-no-width' style={{ width: '5%' }}>#</th>
                <th className='p-2 align-middle' style={{ width: '20%' }}>Voyage number</th>
                <th className='p-2 align-middle text-left' style={{ width: '20%' }}>{previousVoyage ? 'Started On' : 'Voyage status'}</th>
                <th className='p-2 align-middle text-left' style={{ width: '20%' }}>
                    {previousVoyage ? 'Ended On' : 'Departure date & time'}
                    {tab === 2 && (
                        <i
                            id="order-toggle-icon"
                            className={`bx ${order === Order.ASC ? "bx-sort-up" : "bx-sort-down"
                                } ms-2 align-middle pointer color-assign-user icon_s18`}
                            onClick={toggleOrder}
                            onMouseEnter={() => setHoverId("order-toggle-icon")}
                            onMouseLeave={() => setHoverId(null)}
                        />
                    )}
                </th>
                <th
                    className="p-2 align-middle text-center"
                    style={{ width: "30%", cursor: "pointer" }}
                    colSpan={5}
                >
                    Actions{" "}
                </th>
            </tr>

            {hoverId && (
                <ToolTip
                    target="order-toggle-icon"
                    message={order === Order.ASC ? "Sort descending" : "Sort ascending"}
                    isOpen
                />
            )}
        </thead>
    );
};

export default VoyageTableHeadComponent;